import hasRole from './permission/role'
import hasPermissions from './permission/permissions'
import drag from './drag/drag'
const install = function(Vue) {
  Vue.directive('role', hasRole)
  Vue.directive('permissions', hasPermissions)
  Vue.directive('drag', drag)
}

export default install
